export default __webpack_public_path__ + "static/media/scribd.fc67d3fc.svg";